<template>
  <div>
    <div style="margin-bottom: 1.33333rem;">
      <van-nav-bar :title="$route.meta.title" style="max-width: 1000px;left:;">
        <template #right>
          <img :src="rightBtn" style="width: 22px;height: 22px;" @click="handPopShow" />
        </template>
        <template #left>
          <img :src="leftBtn" v-if="!isShowBack" style="width: 22px;height: 22px;" @click="leftPopShow" />
          <van-icon v-if="isShowBack" @click="back" class="#fff" size="20px" name="arrow-left" />
        </template>
      </van-nav-bar>

      <van-popup v-model="show" position="top"
                 style="margin-top:1.33333rem;border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;padding-bottom: 30px;max-width: 1000px;left:unset;">
        <div class="bar-box">
          <div class="titlebar" v-for="item in barList" :key="item.id" @click="handRoute(item.id)">
            <div>
              <img :src="item.url" alt="" style="width: 46px;height: 46px;">
            </div>
            <div>
              {{ item.name }}
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="poor-network-box" :class="{'is-reverse': isReverse}"
         v-show="cPoorNetworkEnvironmentStatus">
      <van-icon name="warning-o" size="18" color="rgb(173, 0, 0)" />
      <!--            <img src="../../../assets/images/tip_err.png" class="tip_err">-->
      <p class="text">当前网络不稳定，数据更新可能会延迟</p>
    </div>
  </div>

</template>

<script>
import { NavBar, Icon, Popup, Col, Row, Dialog } from "vant";
import axios from "axios";
import * as Sentry from "@sentry/vue";

export default {
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Col.name]: Col,
    [Row.name]: Row,
    [Icon.name]: Icon
  },
  computed: {
    isShowBack() {
      return this.$route.meta.headerHasBack;
    },
    cPoorNetworkEnvironmentStatus() {
      return this.$store.state.network.v_poor_network_environment_status;
    },
    isReverse() {
      return this.$store.state.network.v_is_reverse_order;
    }
  },
  data() {
    return {
      rightBtn: "/static/images/rightBtn.png",
      leftBtn: "/static/images/logout.png",
      show: false,
      barList: [
        { name: "策略执行", url: "/static/images/execution.png", id: 6 },
        { name: "交易", url: "/static/images/transaction.png", id: 0 },
        { name: "订单执行", url: "/static/images/order.png", id: 1 },
        { name: "账户明细", url: "/static/images/account_detail.png", id: 2 },
        { name: "账户/组", url: "/static/images/account_group.png", id: 3 },
        { name: "交易设置", url: "/static/images/transaction_settings.png", id: 4 },
        { name: "操作记录", url: "/static/images/operate.png", id: 5 }

      ]
    };
  },
  watch: {
    "$route": {
      handler(val) {
        if (val && !this.$route.meta.isH5Login && this.$route.meta.isH5Page) {
          this.$apis.getTransactionSettingList().then(res => {
            if (this.$route.meta.isH5Axios) {
              this.$localstorage.set("openObj", res.data);
            } else {
              this.$localstorage.set("openObj", res);
            }
          });
        }
        this;
      }
    }
  },
  methods: {
    // 当当前路径为/h5-strategy-execution时，导航到/h5-strategy-home，否则，返回上一页
    back() {
      if (this.$route.path == '/h5-strategy-execution') {
				this.$router.push('/h5-strategy-home');
      } else if (this.$route.path == '/h5-create-strategy') {
        // 从本地存储中获取当前策略ID
        const currentStrategyId = localStorage.getItem('currentStrategyId');
        // 检查是否有当前策略ID
        if (currentStrategyId) {
				  this.$router.push(`/h5-strategy-execution?strategyId=${currentStrategyId}`);
        } else {
          // 如果没有当前策略ID，返回上一页
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    handPopShow() {
      this.show = !this.show;
    },
    handRoute(index) {
      this.$store.commit("network/set_is_reverse_order", false);
      this.show = false;
      switch (index) {
        case 0:
          this.$router.push({
            path: "/h5-page-transaction-home"
          }).catch(err => err);
          break;
        case 1:
          this.$router.push({
            path: "/h5-page-order"
          }).catch(err => err);

          break;
        case 2:
          this.$router.push({
            path: "/h5-page-accountDetails"
          }).catch(err => err);
          break;
        case 3:
          this.$router.push({
            path: "/h5-page-account"
          }).catch(err => err);
          break;
        case 4:
          this.$router.push({
            path: "/h5-page-transaction"
          }).catch(err => err);
          break;
        case 5:
          this.$router.push({
            path: "/h5-page-operation"
          }).catch(err => err);
          break;
        case 6:
          this.$router.push({
            path: "/h5-strategy-home"
          }).catch(err => err);
          break;
        default:
          break;
      }
    },
    leftPopShow() {
      Dialog.confirm({
        title: " ",//这里有个空值，无值在谷歌深色模式 message 会不显示
        message: "确定要退出多账号系统吗？",
        confirmButtonText: "退出"
      }).then(() => {
        this.$apis.apiAuthLogout().then(res => {
          try {
            // sentry监控，移除额外信息
            this.removeInfoFromSentry();
          } catch (err) {
            
          }

          localStorage.removeItem("h5userInfo");//消除h5userInfo
          localStorage.removeItem("token");//消除token
          localStorage.removeItem("oldList"); // 清除oldList(历史选择合约)
          sessionStorage.clear();
          // localStorage.clear();
          localStorage.removeItem("device_no");


          this.$router.replace("/h5-page-login", () => {
            location.reload();
          });//跳回登录页

        });
        //(this as any).$localstorage.removeItem("h5userInfo");
      }).catch((e) => {
        // on cancel
      });

    },
    /**
     * @Description 移除额外信息到Sentry
     * @date 2024/2/1
     * @return {void}
     */
    removeInfoFromSentry() {
      Sentry.configureScope(scope => {
        scope.setUser({});
      });
    }
  }
};
</script>

<style lang="less" scoped>
.bar-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  .titlebar {
    width: 25%;
    text-align: center;
    margin-top: 50px;
  }
}

/deep/ .van-hairline--bottom::after {
  display: none;
}

/deep/ .van-nav-bar__content {
  height: auto;
  padding-top: 4px;
}

/deep/ .van-nav-bar {
  left: unset;
}

.poor-network-box {
  padding-left: 10px;
  display: flex;
  align-items: center;
  height: 50px;
  font-size: 24px;

  background: rgb(255, 225, 225);
  color: rgb(173, 0, 0);

  &.is-reverse {
    margin-top: 150px;
  }

  .text {
    margin-left: 10px;
  }
}
</style>
